import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';

type $tsMigrateAny = any;

const baseHubSpotUrl = getFullUrl('app');

export const getSnippetsUrl = (portalId: $tsMigrateAny) => {
  return `${baseHubSpotUrl}/snippets/${portalId}`;
};

export const getNewSnippetsUrl = (portalId: $tsMigrateAny) => {
  return `${baseHubSpotUrl}/snippets/${portalId}/new`;
};

export const getDocumentsUrl = () => {
  const portalId = PortalIdParser.get();
  return `${baseHubSpotUrl}/presentations/${portalId}`;
};

export const getKnowledgeUrl = (portalId: $tsMigrateAny) => {
  return `${baseHubSpotUrl}/knowledge/${portalId}`;
};

export const getPaymentUrl = (portalId: $tsMigrateAny) => {
  return `${baseHubSpotUrl}/payment-links/${portalId}`;
};

export const getMeetingsUrl = () =>
  `${baseHubSpotUrl}/meetings/${PortalIdParser.get()}`;

export const getInvoicesUrl = () =>
  `${baseHubSpotUrl}/contacts/${PortalIdParser.get()}/objects/0-53/views/all/list`;

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
if (!!module && !!module.exports) {
  module.exports.default = { ...module.exports };
}
